<template>
  <div v-outside-click="hideContextMenu" style="position: relative">
    <sub-context :data="data" :depth="0" @hide-subcontext-menu="hideContextMenu" />
  </div>
</template>

<script>
import { Direction, HotkeyScopes, TreeDefaultNodeIds } from "../../../../utils/constants";
import { icons, ProcessItemTypes, ProcessTypes } from "../../../../utils/icons";
import SubContext from "../SubContext.vue";
import { navigateTo } from "../../../../router";

export default {
  components: {
    SubContext,
  },
  props: ["item"],
  data() {
    return {
      index: -1,
      data: [
        {
          id: 1,
          icon: `${icons.Open}`,
          title: this.$t("contextMenu.open"),
          shortcut: "Enter",
          func: this.open,
          hide: !(
            this.item.type === ProcessItemTypes.Posting ||
            this.item.type === ProcessItemTypes.Normal ||
            this.item.type === ProcessItemTypes.Grid
          ),
          testId: "open-process",
        },
        {
          id: 2,
          icon: `${icons.Plus}`,
          title: this.$t("contextMenu.new"),
          shortcut: `${icons.ChevronRight}`,
          shortcutType: "icon",
          testId: "new-process",
          children: [
            {
              id: 202,
              icon: `${icons[ProcessItemTypes.Normal]}`,
              title: this.$t("contextMenu.normalProcess"),
              shortcut: "nn",
              func: () => this.addProcess(ProcessTypes.Normal),
              testId: "sidebar-new-normal-process",
            },
            {
              id: 201,
              icon: `${icons[ProcessItemTypes.Posting]}`,
              title: this.$t("contextMenu.postingProcess"),
              shortcut: "np",
              func: () => this.addProcess(ProcessTypes.Posting),
              testId: "sidebar-new-posting-process",
            },
            {
              id: 203,
              icon: `${icons[ProcessItemTypes.Folder]}`,
              title: this.$t("contextMenu.folder"),
              shortcut: "nf",
              func: this.addFolder,
              testId: "sidebar-new-folder",
            },
            {
              id: 204,
              icon: `${icons[ProcessItemTypes.SAP]}`,
              title: "Ciclo",
              shortcut: "ns",
              func: this.addSap,
              testId: "sidebar-SAP",
            },
          ],
        },
        {
          id: 3,
          icon: `${icons.Edit}`,
          title: this.$t("contextMenu.edit"),
          shortcut: "F2",
          func: this.editProcess,
          hide: this.item.level === 1,
          testId: "edit-process",
        },
        {
          id: 7,
          icon: `${icons.Maximize}`,
          title: this.$t("contextMenu.expandCollapse"),
          shortcut: "Space",
          func: this.toggleExpanded,
          testId: "expand-collapse-process",
        },
        {
          id: 4,
          icon: `${icons.Move}`,
          title: this.$t("contextMenu.move"),
          shortcut: `${icons.ChevronRight}`,
          shortcutType: "icon",
          hide: this.item.level === 1,
          testId: "move-process",
          children: [
            {
              id: 401,
              icon: `${icons.ChevronUp}`,
              title: this.$t("contextMenu.moveUp"),
              shortcut: "Ctrl + &#8593;",
              func: this.moveUp,
              testId: "process-move-up",
            },
            {
              id: 402,
              icon: `${icons.ChevronDown}`,
              title: this.$t("contextMenu.moveDown"),
              shortcut: "Ctrl + &#8595;",
              func: this.moveDown,
              testId: "process-move-down",
            },
            {
              id: 403,
              icon: `${icons.ChevronLeft}`,
              title: this.$t("contextMenu.moveOneLevelUp"),
              shortcut: "Ctrl + &#8592;",
              func: this.moveOneLevelUp,
              testId: "process-move-one-level-up",
            },
            {
              id: 404,
              icon: `${icons.ChevronRight}`,
              title: this.$t("contextMenu.moveOneLevelDown"),
              shortcut: "Ctrl + &#8594;",
              func: this.moveOneLevelDown,
              testId: "process-move-one-level-down",
            },
          ],
        },
        {
          id: 6,
          icon: `${icons.Trash}`,
          title: this.$t("contextMenu.delete"),
          func: this.removeProcess,
          shortcut: "Delete",
          hide: this.item.level === 1,
          testId: "delete-process",
        },
        {
          id: 9,
          icon: `${icons[ProcessItemTypes.SAP]}`,
          title: this.$t("contextMenu.transfer"),
          func: this.transferToGrid,
          shortcut: "Transfer",
          hide: this.item.level === 1,
          testId: "transfer-to-grid",
        },
        {
          id: 8,
          icon: `${icons.FileConfig}`,
          title: "Permission",
          func: this.permissions,
          // TODO check user permission for same file and add the condition
          hide: !(this.item.type === ProcessItemTypes.Posting || this.item.type === ProcessItemTypes.Normal),
          testId: "permission",
        },
      ],
    };
  },
  mounted() {
    this.$store.dispatch("setScope", HotkeyScopes.SidebarContextMenu);
    const isTrash = this.item.parents[1] === TreeDefaultNodeIds.Trash;
  },
  beforeUnmount() {
    this.resetHotkeyScope();
  },
  methods: {
    clickOutside() {
      this.$store.dispatch("resetActiveContextMenu");
      this.resetHotkeyScope();
    },
    open() {
      this.$store.dispatch("processes/open", this.item.id);
      this.resetHotkeyScope();
    },
    addProcess(type) {
      this.$store.dispatch("processes/addProcess", { id: this.item.id, type });
      this.$store.dispatch("resetActiveContextMenu");
      this.resetHotkeyScope();
    },
    addFolder() {
      this.$store.dispatch("processes/addFolder", this.item.id);
      this.$store.dispatch("resetActiveContextMenu");
      this.resetHotkeyScope();
    },
    async addSap() {
      this.$store.dispatch("cells/setCreateSapDialogVisibility", true);
      this.hideContextMenu();
    },
    editProcess() {
      this.$store.dispatch("processes/setActiveItem", {
        id: this.item.id,
        itemId: this.item.itemId,
        editMode: true,
      });
      this.resetHotkeyScope();
    },
    transferToGrid() {
      this.$store.dispatch("smartSearch/searchAndCall", { value: "transfer to grid", i18n: this.$i18n });
    },
    removeProcess() {
      if (this.$route.params?.id == this.item.itemId) {
        navigateTo("/designs");
        this.$store.dispatch("cells/resetFormulaRange");
        this.$store.dispatch("cells/resetState");
        this.$store.dispatch("pdesign/resetOpenedItem");
      }
      this.$store.dispatch(`processes/remove`, { ids: [this.item.id] });
      this.resetHotkeyScope();
    },
    permissions() {
      this.$store.dispatch(`pdesign/setSelectedItemId`, this.item.itemId);
      this.hideContextMenu();
    },
    moveUp() {
      this.$store.dispatch("processes/moveNode", { id: this.item.id, direction: Direction.Up });
      this.resetHotkeyScope();
    },
    moveDown() {
      this.$store.dispatch("processes/moveNode", { id: this.item.id, direction: Direction.Down });
      this.resetHotkeyScope();
    },
    moveOneLevelUp() {
      this.$store.dispatch("processes/moveNodeOneLevel", { id: this.item.id, direction: Direction.Up });
      this.resetHotkeyScope();
    },
    moveOneLevelDown() {
      this.$store.dispatch("processes/moveNodeOneLevel", { id: this.item.id, direction: Direction.Down });
      this.resetHotkeyScope();
    },
    toggleExpanded() {
      this.$store.dispatch("processes/toggleExpanded", { id: this.item.id, itemId: this.item.itemId });
      this.resetHotkeyScope();
    },
    resetHotkeyScope() {
      this.$store.dispatch("setScope", HotkeyScopes.Sidebar.Processes);
      this.index = -1;
    },
    hideContextMenu() {
      this.$store.dispatch("resetActiveContextMenu");
      this.resetHotkeyScope();
    },
  },
};
</script>
